import {
  Collapse,
  List,
  ListContentIsland,
  NotYetListItem,
  StandingOrderDestinationIcon,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { StandingOrderDestinationListItem } from './StandingOrderDestinationListItem';
import { ApiAccount, ApiBeneficiary, ApiStandingOrderDestination } from '../../../openapi';
import { TransitionGroup } from 'react-transition-group';
import { TerminateStandingOrderDestinationDialog } from './TerminateStandingOrderDestinationDialog';
import { useState } from 'react';

export function StandingOrderDestinations({
  destinations,
  accounts,
  beneficiaries,
}: {
  destinations: ApiStandingOrderDestination[];
  accounts: ApiAccount[];
  beneficiaries: ApiBeneficiary[];
}) {
  const { t } = useTranslation();
  const [destinationToDelete, setDestinationToDelete] = useState<
    ApiStandingOrderDestination | undefined
  >(undefined);

  return (
    <ListContentIsland title={t('Destinations')}>
      <List>
        {destinations.length === 0 ? (
          <NotYetListItem
            title={t('No destinations added yet')}
            icon={<StandingOrderDestinationIcon />}
          />
        ) : null}
        <TransitionGroup>
          {destinations.map((it) => (
            <Collapse key={it.id}>
              <StandingOrderDestinationListItem
                destination={it}
                accounts={accounts}
                beneficiaries={beneficiaries}
                onDelete={setDestinationToDelete}
              />
            </Collapse>
          ))}
        </TransitionGroup>
      </List>
      <TerminateStandingOrderDestinationDialog
        destination={destinationToDelete}
        accounts={accounts}
        beneficiaries={beneficiaries}
        onClose={() => setDestinationToDelete(undefined)}
      />
    </ListContentIsland>
  );
}
